<template>
    <div class="vm-collect flex-box flex-center" @click.stop.prevent="tap">
        <!-- <template></template> -->
        <!-- <i class="afd afd-tongguan"></i>
        <i class="afd afd-forever"></i>-->
        <i class="afd fs14" :class="[mark ? 'afd-star-filled': 'afd-star']"></i>
        <span v-if="!is_only_icon" class="ml8 black-5 fs14">{{mark ? $t('c.Collect.text1'): $t('c.Collect.text2')}}</span>
    </div>
</template>

<script>
import {
    POST_USER_MARK,
    POST_USER_UNMARK
} from "@/api/config";
export default {
  name: "collect",
  props: {
    is_only_icon: {
      default() {
        return false;
      }
    },
    has_mark:{
      default() {
        return 0;
      }
    },
    user_id:{
      default() {
        return '';
      }
    }
  },
  data() {
    return {
        mark:this.has_mark
    };
  },
  mounted() {},
  methods: {
      async tap() {
        let API = this.mark ? POST_USER_UNMARK : POST_USER_MARK;
        this.mark = !this.mark

        if (this.$http.is_run(API)) {
            return false;
        }
        let data = await this.$http.$axios(API, {
            user_id: this.user_id,
        });

        if (data.ec != 200) {
            this.$notify({
                title: data.em,
                group: "error",
            });
            return false;
        }
        this.$notify({
            title: data.em,
            group: "success",
        });
        // this.has_mark = !this.has_mark
        // console.log( this.has_mark ? 0 : 1)
        // this.$emit('updata:has_mark', this.has_mark ? 0 : 1)
    },
    // 'update:has_mark'(){
    //     console.log('=====')
    //     console.log(!this.has_mark)
    //     this.$emit('updata:has_mark', !this.has_mark)
    // }
  }
};
</script>

<style lang="stylus" scoped>
.vm-collect {
    .afd-star-filled {
        color: rgb(252, 178, 57);
    }
    .afd-star{
      color:$black-5;
    }
}
</style>
